import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {LandingHostel} from '../../assets';
import { FaCheck } from "react-icons/fa";
import { Helmet } from "react-helmet";


const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const Page2 = () => {
  const [activeTab, setActiveTab] = useState("sem1");

  const { city } = useParams();
  const [cityName, setCityName] = useState(city ? capitalizeFirstLetter(city) : "");
  useEffect(() => {
    if (city) {
      setCityName(capitalizeFirstLetter(city));
    }
  }, [city]);

  const seoData = {
    Pune: {
      title: "MBA Finance in Pune | Best Program by FINXL Business School",
      description: "Get ready for a successful finance career with MBA Finance in Pune at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Mumbai: {
      title: "MBA Finance Program in Mumbai | Top Ranked College",
      description: "Get a world-class MBA in Finance at FINXL Business School Mumbai. Equip yourself with essential finance skills to succeed in today’s fast-paced industry.",
    },
    Bangalore: {
      title: "MBA Finance College in Bangalore | Secure Your Financial Future",
      description: "Get industry-relevant skills with the MBA Finance Program in Bangalore from FINXL Business School. Learn from top experts and step into the world of finance.",
    },
    Haryana: {
      title: "MBA Finance Program in Haryana | Top Ranked College",
      description: "MBA in Finance in Haryana, MBA Finance in Haryana, MBA Finance College in Haryana, MBA Finance Program in Haryana, Top MBA Finance College in Haryana, MBA and Finance, MBA for Finance in Haryana, Master's in Finance, Master of Business Administration(MBA), Master of Business Administration(MBA) in Haryana",
    },
    Hyderabad: {
      title: "MBA Finance College in Hyderabad | Syllabus, Salary & Jobs",
      description: "MBA in Finance in Hyderabad, MBA Finance in Hyderabad, MBA Finance College in Hyderabad, MBA Finance Program in Hyderabad, Top MBA Finance College in Hyderabad, MBA and Finance, MBA for Finance in Hyderabad, Master's in Finance, Master of Business Administration(MBA)",
    },
    Vadodara: {
      title: "MBA Finance in Vadodara | Best Program by FINXL Business School",
      description: "Get ready for a successful finance career with MBA Finance in Vadodara at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Ahmedabad: {
      title: "MBA Finance in Ahmedabad | Best Program by FINXL Business School",
      description: "Get ready for a successful finance career with MBA Finance in Ahmedabad at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Gurgoan: {
      title: "MBA Finance Program in Gurgoan | 100% Job Guarantee - FBS",
      description: "MBA in Finance in Gurgoan, MBA Finance in Gurgoan, MBA Finance College in Gurgoan, MBA Finance Program in Noida, Top MBA Finance College in Gurgoan, MBA and Finance, MBA for Finance in Gurgoan, Master's in Finance, Master of Business Administration(MBA)",
    },
    Chennai: {
      title: "MBA Finance Program in Chennai | 100% Job Guarantee - FBS",
      description: "MBA in Finance in Chennai, MBA Finance in Chennai, MBA Finance College in Chennai, MBA Finance Program in Chennai, Top MBA Finance College in Chennai, MBA and Finance, MBA for Finance in Chennai, Master's in Finance, Master of Business Administration(MBA)",
    },
    Kolkata: {
      title: "MBA Finance Program in Kolkata | Top Ranked Institute - FBS",
      description: "MBA in Finance in Kolkata, MBA Finance in Kolkata, MBA Finance College in Kolkata, MBA Finance Program in Kolkata, Top MBA Finance College in Kolkata, MBA and Finance, MBA for Finance in Kolkata, Master's in Finance, Master of Business Administration(MBA)",
    },
    Lucknow: {
      title: "MBA Finance in Lucknow | Best Program by FINXL Business School",
      description: "MBA in Finance in Lucknow, MBA Finance in Lucknow, MBA Finance College in Lucknow, MBA Finance Program in Lucknow, Top MBA Finance College in Lucknow, MBA and Finance, MBA for Finance in Lucknow, Master's in Finance, Master of Business Administration(MBA), Master of Business Administration(MBA) in Lucknow",
    },
    Dhanbad: {
      title: "MBA Finance Program in Dhanbad | Top Ranked College",
      description: "Get a world-class MBA in Finance at FINXL Business School Dhanbad. Equip yourself with essential finance skills to succeed in today’s fast-paced industry.",
    },
    Dehradun: {
      title: "MBA Finance Program in Dehradun | Top Ranked College",
      description: "Get a world-class MBA in Finance at FINXL Business School Dehradun. Equip yourself with essential finance skills to succeed in today’s fast-paced industry.",
    },
    Thane: {
      title: "MBA Finance College in Thane | Secure Your Financial Future",
      description: "Get industry-relevant skills with the MBA Finance Program in Thane from FINXL Business School. Learn from top experts and step into the world of finance.",
    },
    Jalgaon: {
      title: "MBA Finance College in Jalgaon | Secure Your Financial Future",
      description: "Get industry-relevant skills with the MBA Finance Program in Jalgaon from FINXL Business School. Learn from top experts and step into the world of finance.",
    },
    Dhule: {
      title: "MBA Finance Program in Dhule | Top Ranked College",
      description: "Get industry-relevant skills with the MBA Finance Program in Dhule from FINXL Business School. Learn from top experts and step into the world of finance.",
    },
    Kannur: {
      title: "MBA Finance Program in Kannur | Top Ranked College",
      description: "Get industry-relevant skills with the MBA Finance Program in Kannur from FINXL Business School. Learn from top experts and step into the world of finance.",
    },
    Kolhapur: {
      title: "MBA Finance College in Kolhapur | Syllabus, Salary & Jobs",
      description: "MBA in Finance in Kolhapur, MBA Finance in Kolhapur, MBA Finance College in Kolhapur, MBA Finance Program in Kolhapur, Top MBA Finance College in Kolhapur, MBA and Finance, MBA for Finance in Kolhapur, Master's in Finance, Master of Business Administration(MBA), Master of Business Administration(MBA) in Kolhapur",
    },
    Ludhiana: {
      title: "MBA Finance College in Ludhiana | Syllabus, Salary & Jobs",
      description: "MBA in Finance in Ludhiana, MBA Finance in Ludhiana, MBA Finance College in Ludhiana, MBA Finance Program in Ludhiana, Top MBA Finance College in Ludhiana, MBA and Finance, MBA for Finance in Ludhiana, Master's in Finance, Master of Business Administration(MBA), Master of Business Administration(MBA) in Ludhiana",
    },
    Jamshedpur: {
      title: "MBA Finance Program in Jamshedpur | 100% Job Guarantee - FBS",
      description: "MBA in Finance in Jamshedpur, MBA Finance in Jamshedpur, MBA Finance College in Jamshedpur, MBA Finance Program in Jamshedpur, Top MBA Finance College in Jamshedpur, MBA and Finance, MBA for Finance in Jamshedpur, Master's in Finance, Master of Business Administration(MBA), Master of Business Administration(MBA) in Jamshedpur",
    },
    Gujarat: {
      title: "MBA Finance Program in Gujarat | Top Ranked Institute - FBS",
      description: "MBA in Finance in Gujarat, MBA Finance in Gujarat, MBA Finance College in Gujarat, MBA Finance Program in Gujarat, Top MBA Finance College in Gujarat, MBA and Finance, MBA for Finance in Gujarat, Master's in Finance, Master of Business Administration(MBA), Master of Business Administration(MBA) in Gujarat",
    },
    Bhopal: {
      title: "MBA Finance Program in Bhopal | Top Ranked Institute - FBS",
      description: "MBA in Finance in Bhopal, MBA Finance in Bhopal, MBA Finance College in Bhopal, MBA Finance Program in Bhopal, Top MBA Finance College in Bhopal, MBA and Finance, MBA for Finance in Bhopal, Master's in Finance, Master of Business Administration(MBA)",
    },
    Nashik: {
      title: "MBA Finance Program in Nashik | FINXL Business School",
      description: "MBA in Finance in Nashik, MBA Finance in Nashik, MBA Finance College in Nashik, MBA Finance Program in Nashik, Top MBA Finance College in Nashik, MBA and Finance, MBA for Finance in Nashik, Master's in Finance, Master of Business Administration(MBA)",
    },
    Jabalpur: {
      title: "MBA Finance College in Jabalpur | Syllabus, Salary & Jobs",
      description: "MBA in Finance in Jabalpur, MBA Finance in Jabalpur, MBA Finance College in Jabalpur, MBA Finance Program in Jabalpur, Top MBA Finance College in Jabalpur, MBA and Finance, MBA for Finance in Jabalpur, Master's in Finance, Master of Business Administration(MBA)",
    },
    Chandigarh: {
      title: "MBA Finance College in Chandigarh | Syllabus, Salary & Jobs",
      description: "MBA in Finance in Chandigarh, MBA Finance in Chandigarh, MBA Finance College in Chandigarh, MBA Finance Program in Chandigarh, Top MBA Finance College in Chandigarh, MBA and Finance, MBA for Finance in Chandigarh, Master's in Finance, Master of Business Administration(MBA)",
    },
    Amravati: {
      title: "MBA Finance Program in Amravati | FINXL Business School",
      description: "MBA in Finance in Amravati, MBA Finance in Amravati, MBA Finance College in Amravati, MBA Finance Program in Amravati, Top MBA Finance College in Amravati, MBA and Finance, MBA for Finance in Amravati, Master's in Finance, Master of Business Administration(MBA)",
    },
    Noida: {
      title: "MBA Finance Program in Noida | Top Ranked Institute",
      description: "MBA in Finance in Noida, MBA Finance in Noida, MBA Finance College in Noida, MBA Finance Program in Noida, Top MBA Finance College in Noida, MBA and Finance, MBA for Finance in Noida, Master's in Finance, Master of Business Administration(MBA)",
    },
    Indore: {
      title: "MBA Finance in Indore | World-Class Education and Placements",
      description: "MBA in Finance in Indore, MBA Finance in Indore, MBA Finance College in Indore, MBA Finance Program in Indore, Top MBA Finance College in Indore, MBA and Finance, MBA for Finance in Indore, Master's in Finance, Master of Business Administration(MBA)",
    },
    Jaipur: {
      title: "MBA Finance Program in Jaipur | FINXL Business School",
      description: "MBA in Finance in Jaipur, MBA Finance in Jaipur, MBA Finance College in Jaipur, MBA Finance Program in Jaipur, Top MBA Finance College in Jaipur, MBA and Finance, MBA for Finance in Jaipur, Master's in Finance, Master of Business Administration(MBA)",
    },
    Kanpur: {
      title: "MBA Finance in Kanpur | World-Class Education and Placements",
      description: "MBA in Finance in Kanpur, MBA Finance in Kanpur, MBA Finance College in Kanpur, MBA Finance Program in Kanpur, Top MBA Finance College in Kanpur, MBA and Finance, MBA for Finance in Kanpur, Master's in Finance, Master of Business Administration(MBA)",
    },
    Nagpur: {
      title: "MBA Finance in Nagpur | World-Class Education and Placements",
      description: "MBA in Finance in Nagpur, MBA Finance in Nagpur, MBA Finance College in Nagpur, MBA Finance Program in Nagpur, Top MBA Finance College in Nagpur, MBA and Finance, MBA for Finance in Nagpur, Master's in Finance, Master of Business Administration(MBA)",
    },
    Patna: {
      title: "MBA Finance in Patna | World-Class Education and Placements",
      description: "MBA in Finance in Patna, MBA Finance in Patna, MBA Finance College in Patna, MBA Finance Program in Patna, Top MBA Finance College in Patna, MBA and Finance, MBA for Finance in Patna, Master's in Finance, Master of Business Administration(MBA)",
    },
    Satara: {
      title: "MBA Finance Program in Satara | FINXL Business School",
      description: "MBA in Finance in Satara, MBA Finance in Satara, MBA Finance College in Satara, MBA Finance Program in Satara, Top MBA Finance College in Satara, MBA and Finance, MBA for Finance in Satara, Master's in Finance, Master of Business Administration(MBA)",
    },
    Sangli: {
      title: "MBA Finance Program in Sangli | FINXL Business School",
      description: "MBA in Finance in Sangli, MBA Finance in Sangli, MBA Finance College in Sangli, MBA Finance Program in Sangli, Top MBA Finance College in Sangli, MBA and Finance, MBA for Finance in Sangli, Master's in Finance, Master of Business Administration(MBA)",
    },
    Agra: {
      title: "MBA Finance Program in Agra | FINXL Business School",
      description: "Get ready for a successful finance career with MBA Finance in Agra at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Varanasi: {
      title: "MBA Finance Program in Varanasi | FINXL Business School",
      description: "Get ready for a successful finance career with MBA Finance in Varanasi at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Prayagraj: {
      title: "MBA Finance Program in Prayagraj | Top Ranked Institute",
      description: "MBA in Finance in Prayagraj, MBA Finance in Prayagraj, MBA Finance College in Prayagraj, MBA Finance Program in Prayagraj, Top MBA Finance College in Prayagraj, MBA and Finance, MBA for Finance in Prayagraj, Master's in Finance, Master of Business Administration(MBA)",
    },
    Amritsar: {
      title: "MBA Finance Program in Amritsar | Top Ranked Institute",
      description: "Get ready for a successful finance career with MBA Finance in Amritsar at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Surat: {
      title: "MBA Finance Program in Surat | Top Ranked Institute",
      description: "Get ready for a successful finance career with MBA Finance in Surat at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Delhi: {
      title: "MBA Finance Program in Delhi | Choose Your Best Career",
      description: "MBA in Finance in Delhi, MBA Finance in Delhi , MBA Finance College in Delhi, MBA Finance Program in Delhi, Top MBA Finance College in Delhi, MBA and Finance, MBA for Finance in Delhi, Master's in Finance, Master of Business Administration(MBA)",
    },
    Solapur: {
      title: "MBA Finance Program in Solapur | Top Ranked College",
      description: "Get ready for a successful finance career with MBA Finance in Solapur at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Bhilai: {
      title: "MBA Finance Program in Bhilai | Top Ranked College",
      description: "MBA in Finance in Bhilai, MBA Finance in Bhilai, MBA Finance College in Bhilai, MBA Finance Program in Bhilai, Top MBA Finance College in Bhilai, MBA and Finance, MBA for Finance in Bhilai, Master's in Finance, Master of Business Administration(MBA)",
    },
    Ranchi: {
      title: "MBA Finance Program in Ranchi | Top Ranked College",
      description: "Get ready for a successful finance career with MBA Finance in Ranchi at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Guwahati: {
      title: "MBA Finance in Guwahati | Best Program by FINXL Business School",
      description: "MBA in Finance in Guwahati, MBA Finance in Guwahati, MBA Finance College in Guwahati, MBA Finance Program in Guwahati, Top MBA Finance College in Guwahati, MBA and Finance, MBA for Finance in Guwahati, Master's in Finance, Master of Business Administration(MBA)",
    },
    Gwalior: {
      title: "MBA Finance in Gwalior | Best Program by FINXL Business School",
      description: "MBA in Finance in Gwalior, MBA Finance in Gwalior, MBA Finance College in Gwalior, MBA Finance Program in Gwalior, Top MBA Finance College in Gwalior, MBA and Finance, MBA for Finance in Gwalior, Master's in Finance, Master of Business Administration(MBA)",
    },
    "Hubballi-Dharwad": {
      title: "MBA Finance in Hubballi-Dharwad | Best Program by FINXL Business School",
      description: "Get ready for a successful finance career with MBA Finance in Hubballi-Dharwad at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Visakhapatnam: {
      title: "MBA Finance in Visakhapatnam | Best Program by FINXL Business School",
      description: "Get ready for a successful finance career with MBA Finance in Visakhapatnam at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Bhubaneswar: {
      title: "MBA Finance College in Bhubaneswar |Secure Your Financial Future",
      description: "MBA in Finance in Bhubaneswar, MBA Finance in Bhubaneswar, MBA Finance College in Bhubaneswar, MBA Finance Program in Bhubaneswar, Top MBA Finance College in Bhubaneswar, MBA and Finance, MBA for Finance in Bhubaneswar, Master's in Finance, Master of Business Administration(MBA)",
    },
    "Navi-Mumbai": {
      title: "MBA Finance College in NaviMumbai |Secure Your Financial Future",
      description: "Get ready for a successful finance career with MBA Finance in Navi-Mumbai at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    Aurangabad: {
      title: "MBA Finance College in Aurangabad |Secure Your Financial Future",
      description: "Get ready for a successful finance career with MBA Finance in Aurangabad at FINXL Business School. Learn from experts and get hands-on experience in the finance.",
    },
    "Vasai-Virar": {
      title: "MBA Finance in Vasai-Virar | World-Class Education and Placements",
      description: "MBA in Finance in Vasai-Virar, MBA Finance in Vasai-Virar, MBA Finance College in Vasai-Virar, MBA Finance Program in Vasai-Virar, Top MBA Finance College in Vasai-Virar, MBA and Finance, MBA for Finance in Vasai-Virar, Master's in Finance, Master of Business Administration(MBA)",
    },
    "Pimpri-Chinchwad": {
      title: "MBA Finance in Pimpri-Chinchwad | World-Class Education and Placements",
      description: "MBA in Finance in Pimpri-Chinchwad, MBA Finance in Pimpri-Chinchwad, MBA Finance College in Pimpri-Chinchwad, MBA Finance Program in Pimpri-Chinchwad, Top MBA Finance College in Pimpri-Chinchwad, MBA and Finance, MBA for Finance in Pimpri-Chinchwad, Master's in Finance, Master of Business Administration(MBA)",
    },
    Maharashtra: {
      title: "MBA Finance Program in Maharashtra | FINXL Business School",
      description: "MBA in Finance in Maharashtra, MBA Finance in Maharashtra, MBA Finance College in Maharashtra, MBA Finance Program in Maharashtra, Top MBA Finance College in Maharashtra, MBA and Finance, MBA for Finance in Maharashtra, Master's in Finance, Master of Business Administration(MBA), Master of Business Administration(MBA) in Maharashtra",
    },
    India: {
      title: "MBA Finance Program in India | FINXL Business School",
      description: "MBA in Finance in India, MBA Finance in India, MBA Finance College in India, MBA Finance Program in India, Top MBA Finance College in India, MBA and Finance, MBA for Finance in India, Master's in Finance, Master of Business Administration(MBA), Master of Business Administration(MBA) in India",
    },
  };
  const { title, description } = seoData[cityName] || {
    title: "Finxl Business School (FBS) | Best Program by FINXL Business School",
    description: "Get a world-class MBA Finance in India at FINXL Business School. Equip yourself with essential finance skills to succeed in today’s fast-paced industry.",
  };


  useEffect(() => {
    if (city) {
      setCityName(capitalizeFirstLetter(city));
    }
  }, [city]);

  const semesters = {
    sem1: {
      compulsory: [
        "Managerial Accounting",
        "Organizational Behavior",
        "Economics Analysis for Business",
        "Business Research Methodology",
        "Basics of Marketing",
        "Digital Business",
      ],
      electives: [
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Management Fundamentals",
            "Indian Economy",
            "Legal Aspects of Business",
            "Verbal Communication Lab",
            "MS Excel",
            "Entrepreneurship- Managing Skills for MSMEs-Seminar",
            "Desk Research- Best Business Practices-Case Study",
          ],
        },
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Verbal Communication Lab",
            "Enterprise Analysis & Desk Research",
            "Selling & Negotiation Skills Lab",
            "MS Excel",
            "Business Systems & Procedures",
            "Managing Innovation",
            "Foreign Language – I",
          ],
        },
      ],
    },
    sem2: {
      compulsory: [
        "Marketing Management",
        "Financial Management",
        "Human Resources Management",
        "Operations & Supply Chain Management",
        "Personal Financial Planning",
        "Financial Markets and Banking Operations",
      ],
      electives: [
        {
          note: "Any 3 courses to be selected from the following list",
          subjects: [
            "Contemporary Frameworks in Management",
            "Geopolitics & World Economic Systems",
            "Start Up and New Venture Management",
            "Qualitative Research Methods",
            "Business, Government & Society",
            "Business Process Re-engineering",
          ],
        },
        {
          note: "Maximum 1 course to be selected from the following list",
          subjects: [
            "Written Analysis and Communication Lab",
            "Industry Analysis & Desk Research",
            "Entrepreneurship Lab",
            "SPSS",
            "Foreign Language II",
          ],
        },
        {
          note: "Maximum 2 courses to be selected from the following list",
          subjects: [
            "Securities Analysis & Portfolio Management",
            "Futures and Options",
            "Direct Taxation",
            "Financial Reporting",
            "Retail Credit Management- Lending & Recovery",
            "Banking Laws & Regulations",
            "Fundamentals of Life Insurance – Products and Underwriting",
            "General Insurance - Health and Vehicle",
          ],
        },
      ],
    },
    sem3: {
      compulsory: [
        "Strategic Management",
        "Decision Science",
        "Summer Internship Project",
        "Advanced Financial Management",
        "International Finance",
      ],
      electives: [
        {
          note: "Any 3 courses to be selected from the following list",
          subjects: [
            "International Business Economics",
            "International Business Environment",
            "Project Management",
            "Quality Management",
            "Corporate Governance",
            "Management of Non-profit organizations",
          ],
        },
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Behavioral Finance",
            "Commodities Markets",
            "Indirect Taxation",
            "Corporate Financial Restructuring",
            "Financial Modeling",
            "FIN Digital Banking",
            "Treasury Management",
            "Project Finance and Trade Finance",
            "Insurance Laws & Regulations",
            "Marine Insurance",
            "Fire Insurance",
          ],
        },
      ],
    },
    sem4: {
      compulsory: [
        "Enterprise Performance Management",
        "Indian Ethos & Business Ethics",
        "Financial Laws",
        "Current Trends & Cases in Finance",
      ],
      electives: [
        {
          note: "Any 2 courses to be selected from the following list",
          subjects: [
            "Global Strategic Management",
            "Elective Competing in Global Markets",
            "Elective Cyber Laws",
            "CSR & Sustainability",
          ],
        },
        {
          note: "Maximum 2 courses to be selected from the following list",
          subjects: [
            "Fixed Income Securities",
            "Business Valuation",
            "Risk Management",
            "Strategic Cost Management",
            "Rural and Micro Finance",
            "Reinsurance",
            "Agricultural Insurance",
          ],
        },
      ],
    },
  };



  return (
  <>
  <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content={`MBA in Finance in ${cityName}, MBA Finance in ${cityName}, MBA Finance College in ${cityName}, MBA Finance Program in ${cityName}, Top MBA Finance College in ${cityName}, MBA and Finance, MBA for Finance in ${cityName}, Master's in Finance, Master of Business Administration(MBA).`}
        />
        <link rel="canonical" href={`https://www.fbsedu.in/mba-in-finance/${cityName.toLowerCase()}`} />
      </Helmet>
    

    <div className="max-w-7xl mx-auto py-6 px-6">
      <h1 className="text-3xl font-extrabold text-center text-blue-600 mb-4">
        {cityName ? `MBA Finance Program in ${cityName}` : `MBA in Finance`}
      </h1>

      {/* About Section */}
      <section className="flex flex-col md:flex-row items-center bg-white p-6 rounded-lg shadow-lg mb-6" id="about-section">
        {/* Left Text Section */}
        <div className="bg-blue-50 p-6  rounded-lg md:w-1/2">
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            {cityName ? `Join Our MBA Finance Program in ${cityName}` : `Join Our MBA Finance Program`}
          </h2>
          <p className="text-gray-700 mb-4">
            Empowering future finance leaders through innovative education and
            guaranteed placements.
          </p>
          <a
            href="https://fbsedu.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-orange-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-orange-600">
              Get in touch with us
            </button>
          </a>
        </div>

        {/* Right Image Section */}
        <div className="md:w-1/2 flex justify-center mt-4 md:mt-0">
          <img
            src={LandingHostel}
            alt="MBA Finance Program"
            className="max-w-full h-auto rounded-lg"
          />
        </div>
      </section>


      {/* About MBA Finance Course Section */}
      <section className="bg-white p-4 sm:p-6 rounded-lg shadow-lg mb-6" id="about-course-section">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 text-left">
          {cityName ? `About MBA Finance in ${cityName} Course` : `About MBA Finance Course`}
        </h2>
        <ul className="text-gray-700 space-y-3">
          <li className="flex items-start text-sm sm:text-base">
            <FaCheck className="text-green-600 mt-1 mr-2" />
            The {cityName ? `MBA Finance in ${cityName}` : `MBA Finance`} is a 2-year full-time program designed to equip students with financial skills.
          </li>
          <li className="flex items-start text-sm sm:text-base">
            <FaCheck className="text-green-600 mt-1 mr-2" />
            Real-time case studies, expert support, resume preparation, lifetime access to FINXL LMS.
          </li>
          <li className="flex items-start text-sm sm:text-base">
            <FaCheck className="text-green-600 mt-1 mr-2" />
            FBS guarantees placement in the core finance sector with a one-year job experience letter.
          </li>
          <li className="flex items-start text-sm sm:text-base">
            <FaCheck className="text-green-600 mt-1 mr-2" />
            Attractive return on investment with competitive salary packages.
          </li>
        </ul>

        {/* Who Should Apply Section */}
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mt-6 mb-4 text-left">
          {cityName ? `Who Should Apply For MBA Finance Program in ${cityName}?` : `Who Should Apply For MBA Finance Program ?`}
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 justify-center p-2 sm:p-4">
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Those looking to specialize in financial analysis and equity research.
          </div>
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Individuals aiming to excel in investment banking.
          </div>
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Professionals seeking to provide strategic financial advice.
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-2 sm:p-4">
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Working Professionals: Executive MBA, part-time MBA, online MBA, and accelerated programs.
          </div>
          <div className="bg-orange-200 p-6 sm:p-8 rounded-lg text-center font-semibold min-h-[120px] sm:min-h-[150px] flex items-center justify-center hover:bg-orange-300 hover:shadow-xl transition-all duration-300">
            Graduates with a bachelor's degree and a passion for finance.
          </div>
        </div>
      </section>

      {/* Eligibility Section */}
      <section className="bg-white p-6 rounded-lg shadow-lg mb-6" id="eligibility-section">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          {cityName ? `Who is Eligible for the MBA Finance Program in ${cityName}?` : `Who is Eligible for the MBA Finance Program ? `}
        </h2>
        <div className="flex flex-col md:flex-row font-semibold justify-center items-center gap-12 md:gap-16 mb-8">
          {/* Small Circle */}
          <div
            className="w-40 h-40 flex items-center justify-center rounded-full text-center p-4 
                  bg-gradient-to-r from-blue-400 to-blue-600 text-white shadow-lg
                  transition-transform transform hover:scale-110 hover:shadow-2xl"
          >
            A bachelor's degree with a minimum of 50% marks.
          </div>

          {/* Larger Circle */}
          <div
            className="w-60 h-60 flex items-center justify-center rounded-full text-center p-6 font-semibold
                  bg-gradient-to-r from-orange-400 to-orange-600 text-white shadow-xl
                  transition-transform transform hover:scale-110 hover:shadow-2xl"
          >
            Based on academic performance, entrance exam scores, and personal
            interviews.
          </div>

          {/* Small Circle */}
          <div
            className="w-40 h-40 flex items-center justify-center rounded-full text-center p-4
                  bg-gradient-to-r from-green-400 to-green-600 text-white shadow-lg
                  transition-transform transform hover:scale-110 hover:shadow-2xl"
          >
            CAT, CMAT, MAT, XAT, MH-CET.
          </div>
        </div>

        {/* Program Features */}
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Program Features
        </h2>
        <div className="bg-blue-100 p-6 rounded-lg">
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-900">
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Online support from a dedicated team for all queries.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Assistance in resume building and job portal updates.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Obtain certifications in financial modeling, equity research,
              and advanced Excel.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Access to FINXL LMS with videos, spreadsheets, presentations,
              ebooks, quizzes, and case studies.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>Live case studies for each financial topic to ensure thorough
              understanding.
            </li>
            <li className="flex items-start">
            <FaCheck className="text-purple-600 mt-1 mr-2 h-4 w-4"/>A dynamic platform to connect with experts across the globe.
            </li>
          </ul>
        </div>
      </section>


      {/* Admissions Process */}
      <section className="bg-white p-6 rounded-lg shadow-lg mb-6" id="admission-section">
        <div className="p-6">
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Admissions Process
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Step 1 */}
              <div className="flex items-start space-x-4">
                <span className="text-red-600 text-xl font-bold">Step 01</span>
                <span className="border-l-2 border-gray-500 pl-4 text-gray-700">
                  Online application form available on the FBS website.
                </span>
              </div>
              {/* Step 2 */}
              <div className="flex items-start space-x-4">
                <span className="text-red-600 text-xl font-bold">Step 02</span>
                <span className="border-l-2 border-gray-500 pl-4 text-gray-700">
                  CAT, CMAT, MAT, XAT, MH-CET.
                </span>
              </div>
              {/* Step 3 */}
              <div className="flex items-start space-x-4">
                <span className="text-red-600 text-xl font-bold">Step 03</span>
                <span className="border-l-2 border-gray-500 pl-4 text-gray-700">
                  Personal interviews for shortlisted candidates.
                </span>
              </div>
              {/* Step 4 */}
              <div className="flex items-start space-x-4">
                <span className="text-red-600 text-xl font-bold">Step 04</span>
                <span className="border-l-2 border-gray-500 pl-4 text-gray-700">
                  Based on performance in entrance exams and interviews.
                </span>
              </div>
            </div>
          </section>
        </div>

        {/* How We Train */}

        {/* Placements */}
        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Placements</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center h-100 p-6">
            <div className="bg-blue-600 text-white p-6 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105">
              <p className="text-xl font-bold">INR 7.00 Lakh</p>
              <p className="text-sm">Average Package</p>
            </div>
            <div className="bg-blue-600 text-white p-6 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105">
              <p className="text-xl font-bold">INR 22.00 Lakh</p>
              <p className="text-sm">Highest Package</p>
            </div>
            <div className="bg-blue-600 text-white p-6 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105">
              <p className="text-xl font-bold">100% placement</p>
              <p className="text-sm">Placement Rate</p>
            </div>
          </div>
        </section>
      </section>
      {/* MBA Finance Syllabus */}
      <div className="w-full mx-auto p-4 bg-white rounded-lg shadow-lg">
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
          {cityName ? `MBA Finance in ${cityName}` : `MBA Finance`} Syllabus
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            The {cityName ? `MBA Finance in ${cityName}` : `MBA Finance`} syllabus at FBS is carefully crafted to give you a
            competitive edge. Explore the courses across different semesters:
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg">
          <div className="border-b">
            <nav className="flex flex-wrap justify-center">
              {["SEMESTER I", "SEMESTER II", "SEMESTER III", "SEMESTER IV"].map(
                (sem, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveTab(`sem${idx + 1}`)}
                    className={`px-6 py-3 font-medium text-sm transition-colors
                    ${activeTab === `sem${idx + 1}`
                        ? "border-b-2 border-blue-500 text-blue-600"
                        : "text-gray-500 hover:text-gray-700"
                      }`}
                  >
                    {sem}
                  </button>
                )
              )}
            </nav>
          </div>

          {/* Semester Content */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  <th className="p-4 text-center text-sm font-medium text-gray-600 border">
                    Semester
                  </th>
                  <th className="p-4 text-center text-sm font-medium text-gray-600 border">
                    Subject
                  </th>
                  <th className="p-4 text-center text-sm font-medium text-gray-600 border">
                    Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Compulsory Subjects */}
                <tr>
                  <td className="p-4 border">SEMESTER {activeTab.slice(-1)}</td>
                  <td className="p-4 border">
                    <ul className="list-disc pl-5 space-y-1">
                      {semesters[activeTab].compulsory.map((subject, idx) => (
                        <li key={idx}>{subject}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="p-4 border">Compulsory</td>
                </tr>

                {/* Electives Sections */}
                {semesters[activeTab].electives.map((section, sectionIdx) => (
                  <React.Fragment key={sectionIdx}>
                    <tr>
                      <td
                        colSpan="3"
                        className="p-4 border font-medium text-center bg-gray-50"
                      >
                        {section.note}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-4 border">
                        SEMESTER {activeTab.slice(-1)}
                      </td>
                      <td className="p-4 border">
                        <ul className="list-disc pl-5 space-y-1">
                          {section.subjects.map((subject, idx) => (
                            <li key={idx}>{subject}</li>
                          ))}
                        </ul>
                      </td>
                      <td className="p-4 border">Electives</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default Page2;
